import http, { AUTH_ROUTES } from '../../../services/api';
import { errorNotifier } from '../../../components/NotificationHandler';

const forceLogout = (reason) => {
  localStorage.removeItem('11p221#');
  localStorage.removeItem('userId');
  errorNotifier(reason);

  setTimeout(() => {
    window.location.href = '/login';
  }, 2000);
};

export const getUserProfile = async (userId, setIsLoading, setUserProfile) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_USER_PROFILE(userId));

    const profileData = data?.user || data || {};
    const outstandingBalance = Number(profileData?.outstandingBalance || 0);
    const shouldRestrict = profileData?.shouldRestrict === true;

    if (outstandingBalance > 0 && shouldRestrict) {
      forceLogout(`Your account is restricted due to an outstanding balance of ₦${outstandingBalance.toFixed(2)}.`);
      return;
    }

    setUserProfile(profileData);
    setIsLoading(false);
  } catch (error) {
    console.log('lllll', error.response);
  } finally {
    setIsLoading(false);
  }
};
